export class ApplicationError implements Error {
  errorCode = -1000;
  name = '不明なエラー';
  message = '不明なエラーです。時間をおいて再度お試しください。';

  constructor(message?: string) {
    if (message) this.message = message;
  }

  toString(): string {
    return this.message + ': error-code=' + this.errorCode;
  }
}

// api
export class NetworkError extends ApplicationError {
  errorCode = 1001;
  name = 'ネットワークエラー';
  message = 'ネットワークエラーです。OKを押すとリトライします。';
}

// auth
export class AuthenticationFailedError extends ApplicationError {
  errorCode = 2001;
  name = '認証エラー';
  message = 'アカウント認証に失敗しました。ログアウトします。';
}


// facebook login
export class FacebookLoginError extends ApplicationError {
  errorCode = 2001;
  name = 'Facebookログインエラー';
  message = 'Facebookログインに失敗しました。';
}


// WEBPACK FOOTER //
// ./src/providers/errors.ts